<template>
    <div class="block block-content-full">
        <div v-if="!user">Loading...</div>
        <div v-else>
            <div class="col-md-12 col-lg-10 mt-10">
                <form class="js-validation-signin">
                    <div>
                        <div class="form-group row">
                            <div class="col-lg-6">
                                <label for="firstname">ACCESS ID</label>
                                <input
                                    id="firstname"
                                    type="text"
                                    class="form-control"
                                    disabled
                                    v-model="user.access_id"
                                />
                            </div>
                            <div class="col-lg-6">
                                <label for="firstname">ACCOUNT NUMBER</label>
                                <input
                                    id="firstname"
                                    type="text"
                                    class="form-control"
                                    disabled
                                    v-model="user.account"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-6">
                                <label for="firstname">FIRSTNAME</label>
                                <input
                                    id="firstname"
                                    type="text"
                                    class="form-control"
                                    required
                                    name="firstname"
                                    placeholder="Enter firstname"
                                    autocomplete="phone"
                                    v-model="user.first_name"
                                />
                            </div>
                            <div class="col-lg-6">
                                <label for="lastname">LASTNAME</label>
                                <input
                                    id="lastname"
                                    name="lastname"
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter lastname"
                                    required
                                    autocomplete="phone"
                                    v-model="user.last_name"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-6">
                                <label for="phonw">PHONE</label>
                                <input
                                    id="phone"
                                    type="text"
                                    class="form-control"
                                    required
                                    placeholder="Enter phone number"
                                    autocomplete="phone"
                                    v-model="user.phone"
                                />
                            </div>
                            <div class="col-lg-6">
                                <label for="email">EMAIL</label>
                                <input
                                    id="email"
                                    type="text"
                                    class="form-control"
                                    required
                                    placeholder="Enter email address"
                                    autocomplete="email"
                                    v-model="user.email"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-6">
                                <label for="gender">GENDER</label>
                                <select
                                    v-model="user.gender"
                                    name="gender"
                                    id="gender"
                                    class="form-control"
                                >
                                    <option selected disabled value=""
                                        >-- Choose Gender --</option
                                    >
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Others">Others</option>
                                </select>
                            </div>
                            <div class="col-lg-6">
                                <label for="login-password"
                                    >DATE OF BIRTH</label
                                >
                                <input
                                    v-model="user.dob"
                                    type="date"
                                    class="js-datepicker form-control"
                                    id="example-datepicker3"
                                    name="example-datepicker3"
                                    data-week-start="1"
                                    data-autoclose="true"
                                    data-today-highlight="true"
                                    data-date-format="dd-mm-yyyy"
                                    placeholder="dd-mm-yyyy"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-6">
                                <label for="country">COUNTRY</label>
                                <country-select
                                    class="form-control"
                                    v-model="user.country"
                                    :country="user.country"
                                    topCountry="US"
                                />
                            </div>
                            <div class="col-lg-6">
                                <label for="login-password">STATE</label>
                                <region-select
                                    class="form-control"
                                    v-model="user.state"
                                    :country="user.country"
                                    :region="user.state"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-6">
                                <label for="firstname">ADDRESS</label>
                                <input
                                    id="address"
                                    d
                                    type="text"
                                    class="form-control"
                                    required
                                    placeholder="Enter address"
                                    v-model="user.address"
                                />
                            </div>
                            <div class="col-lg-6">
                                <label for="lastname">CITY</label>
                                <input
                                    id="city"
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter city"
                                    required
                                    v-model="user.city"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <button
                            @click.prevent="updateUser"
                            type="submit"
                            class="btn btn-info mb-10"
                        >
                            Update Information
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "../repository/RepositoryFactory";
const UsersRepository = RepositoryFactory.get("users");
export default {
    props: {
        user: Object,
        require: true
    },
    data() {
        return {
            processing: false,
            image_url: "",
            avatar: "",
            file: "",
            date: "",
            amount: 0,
            currency: 8
        };
    },
    methods: {
        async updateUser() {
            try {
                this.processing = true;

                let data = {
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    email: this.user.email,
                    dob: this.user.dob,
                    state: this.user.state,
                    country: this.user.country,
                    gender: this.user.gender,
                    phone: this.user.phone,
                    currency: this.user.currency,
                    account_type: this.user.account_type,
                    address: this.user.address,
                    city: this.user.city
                };

                await UsersRepository.updateProfile(data);
                toast.fire({
                    type: "success",
                    title: "Update successful"
                });

                this.processing = false;
                this.refresh();
                return true;
            } catch (error) {
                this.processing = false;
                if (error.response.status == 422) {
                    toast.fire({
                        type: "error",
                        title: error.response.data.errors.email[0]
                    });
                } else {
                    toast.fire({
                        type: "error",
                        title: "Something went wrong"
                    });
                }
            }
        },
        refresh() {
            this.$emit("refresh");
        },
        thankYou() {
            window.location = "/profile";
        }
    }
};
</script>

<style scoped></style>
